/**
 * Set to `true` while testing the first-launch auth dialog.
 * When enabled, the dialog ignores AsyncStorage dismiss, post-sign-out suppression,
 * and the “opened Auth from modal” session guard. Dismissal does not persist while
 * this flag is on (so you can reload and see it again without clearing storage).
 */
export const FORCE_AUTH_FIRST_LAUNCH_MODAL = false;
